module.exports = __webpack_public_path__ + "static/fonts/RobotoFlex-Regular.c1f174f3.ttf";